import home from "./home";
import userCategory from "./userCategory";
import course from "./course";
import classApi from "./class";
import courseCategory from "./courseCategory";
import user from "./user";
import province from "./province";
import offCode from "./offCode";

export default {
    home,
    classApi,
    course,
    courseCategory,
    userCategory,
    user,
    province,
    offCode,
}
